import { generateImagePath, getChimeImage, getChimeText, addChimeToggleClass, shouldBeVisibleByStateCheck } from "../util/Misc";
import PrintMgr from "../util/PrintMgr";
import ModalMgr from "../util/ModalMgr";
import { CHAT_STATE, EMAIL_STATE } from "../model/Constants";
import {overflowitemRender} from "./templates/renders/overflowitem";
import ChatPosition from "../util/ChatPosition";

/**
 * Creates an Over flow item custom element
 * @type {{template, onMenuClick(*): void, created(): void, tagName: string}}
 */
const OverFlowItem: any = {
    tagName: "overflow-item",
    initialize(options) {
        initComponent(options);
    },
    renderer: overflowitemRender,
    onMenuClick(event) {
        const type = this.prop.type;
        const modalManager = new ModalMgr(this.$app);

        if (this.data.disabled) {
            return;
        }

        switch (type) {
            case "Close":
                this.$app.closeChat();
                break;

            case "Minimize":
                this.$app.minimize();
                break;

            case "Email":
                modalManager.requestEmail();
                break;

            case "Chime":
                this.toggleChime();
                break;

            case "Print":
                PrintMgr.displayPrintWindow(this.$app);
                break;

            case "Info":
                modalManager.displayInfoModalWindow(this.prop.content);
                break;

            case "Move":
                ChatPosition.togglePosition();
                break;

            // no default
        }

        this.$app.shoutui.getLayoutEl().onLayoutClick();
        event.preventDefault();
        event.stopPropagation();
    },
    created() {
        this.parentEl = this.el.parentElement;
        const stateMgr = this.$app.getStateMgr();
        this.visible = true;
        this.processHiddenDevice(this.prop);

        if (this.prop.hiddenstates && this.visible) {
            this.handleComponentVisibility(stateMgr.state.state);
            this.subscribeToStateMgr();
        }

        if (this.prop.type == "Email" && this.visible) {
            this.subscribeToStateMgr();
            this.emailStateListenerId = this.$app.getStateMgr().subscribe(emailState => {
                this.disableData(emailState);
            }, "emailState");
        }

        if (this.prop.type == "Chime" && this.visible) {
            addChimeToggleClass(this.$app.isSoundEnabled(), this.el);
        }
    },
    subscribeToStateMgr() {
        if (typeof this.stateListenerId === "undefined") {
            this.stateListenerId = this.$app.getStateMgr().subscribe(
                (state) => this.chatStateListener(state), 
                "state"
                );
        }
    },
    enable() {
        // this.el.firstElementChild.classList.remove("disabled")
        this.data.disabled = false;
    },
    setDisable() {
        this.data.disabled = true;
    },
    toggleChime() {
        this.$app.setSoundState(!this.$app.isSoundEnabled());
        this.el.firstElementChild.querySelector("img").src = generateImagePath(getChimeImage(this.prop, this.$app), this.$app);
        this.el.firstElementChild.querySelector("span").innerText = getChimeText(this.prop.text, this.$app);
        addChimeToggleClass(this.$app.isSoundEnabled(), this.el);
    },

    /**
     * passing engaged state so that if any of the menu buttons need to be enabled
     */
    chatStateListener(state) {
        if (this.prop.type == "Email") {
            this.enableData(state);
        }

        this.handleComponentVisibility(state)
    },
    enableData(state) {
        if (state == CHAT_STATE.ENGAGED && !this.$app.isEmailRequested() && this.data.disabled) {
            this.enable();
        }
    },
    disableData(state) {
        if ((state == EMAIL_STATE.REQUESTED) && !this.data.disabled) {
            this.setDisable();
        }
    },
    processHiddenDevice(propObj) {
        if (propObj.hiddendevices) {
            if (propObj.hiddendevices
                .indexOf(this.$app.getSDKInstance().getDeviceType()) !== -1) {
                this.visible = false;
                this.el.style.display = "none";
            }
        }
    },
    handleComponentVisibility(state){
        if (!this.prop.hiddenstates) {
            return;
        }

        let visibility = shouldBeVisibleByStateCheck(state, this.prop.hiddenstates);

        if (visibility && !this.visible) {
            this.el.style.display = null;
        } else if (!visibility && this.visible) {
            this.el.style.display = "none";
        }

        this.visible = visibility;
    },
    removed() {
        const stateMgr = this.$app.getStateMgr();

        if (typeof this.emailStateListenerId !== "undefined") {
            stateMgr.unsubscribe(this.emailStateListenerId);
        }

        if (typeof this.stateListenerId !== "undefined") {
            stateMgr.unsubscribe(this.stateListenerId);
        }
    },
};

/**
 * @export OverFlowItem
 * @param {CIApp} appInstance
 * @return {{template, onMenuClick, (*): void, created, (): void, tagName: string}}
 */
export default appInstance => {
    OverFlowItem.$app = appInstance;
    return OverFlowItem;
};

const initComponent = (options: any) => {
    const appInstance = options.$app;
    const appConfig = appInstance.getUIConfig();

    options.data = {
        imgUrl: state => {
            let imgObj = state.prop;

            if (imgObj.type == "Chime") {
                imgObj = getChimeImage(state.prop, appInstance);
            }
            return generateImagePath(imgObj, appInstance);
        },
        disabled: state => {
            if (state.prop.type == "Email") {
                if (!appInstance.getSDKInstance().isChatInProgress()) {
                    return true;
                }

                if (appInstance.isEmailRequested()) {
                    return true;
                }
            }
            return false;
        },
        text: state => {
            if (state.prop.type == "Chime") {
                const text = state.prop.text;
                return getChimeText(text, appInstance);
            }
            return state.prop.text;
        },
    };

    if (appConfig.topBarConfig) {
        const tpConfig = appConfig.topBarConfig;
        options.constants = { overFlowItemStyle: tpConfig.overFlowMenuItemStyle };
    }
};
